const restuarant_problem = `Hei Petteri,
Minulla oli tänään eniten pettymys ravintolassa, ja minun oli vain jaettava se kanssasi.
Kaikki näytti menevän pieleen.
Ensinnäkin palvelu oli uskomattoman hidasta, ja kesti aikoja ennen kuin ruokamme saapui.
Sitten, kun se lopulta tapahtui, tilaukseni oli täysin väärä. Se tuntui sarjalta ikäviä tapahtumia.
Odotin todella innolla mukavan aterian nauttimista, mutta koko kokemus sai minut turhautumaan ja pettymään.
Se on niin sääli, koska olin kuullut hyvää paikasta aiemmin.
Juuri nyt ajattelin ottaa yhteyttä ravintolan johtoon ilmaistakseni huoleni ja katsoa, selviävätkö he asian jotenkin.
Haluan myös antaa heille palautetta, jotta he voivat parantaa palveluitaan muille asiakkaille.
Toivottavasti he ottavat palautteeni vakavasti ja pyrkivät parantamaan asioita.
Kerron kuinka käy.
Kiitos kuuntelemisesta!
terveisin`;

export default restuarant_problem;